import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../../StateContext/Application";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../../styles/GooglePagination";
import {apiurl} from '../../../../../path';
const ProposalList = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetProposallist } = context;
  const [proposallist, setProposalList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  console.log("proposallist: ", proposallist);

  const proposalEstimate = async () => {
    let data = await GetProposallist();
    setProposalList(data.message);
  };

  useEffect(() => {
    proposalEstimate();
  }, []);

  useEffect(() => {
    let filtered = proposallist;

    // Search term filtering
    const lowerSearchTerm = searchTerm.toLowerCase();
    filtered = filtered.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );

    // Year filtering
    if (selectedYear) {
      filtered = filtered.filter((bill) => bill.Proposal_year === selectedYear);
    }

    // Taluka filtering
    if (selectedTaluka) {
      filtered = filtered.filter((bill) => bill.Taluka === selectedTaluka);
    }

    setFilteredBills(filtered);
  }, [searchTerm, selectedYear, selectedTaluka, proposallist]);

  // Get unique years and talukas for dropdowns
  const years = [...new Set(proposallist.map((bill) => bill.Proposal_year))];

  // Filter Talukas based on the selected Year
  const talukas = selectedYear
    ? [
        ...new Set(
          proposallist
            .filter((bill) => bill.Proposal_year === selectedYear)
            .map((bill) => bill.Taluka),
        ),
      ]
    : [...new Set(proposallist.map((bill) => bill.Taluka))];

  // return (
  //     <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px",height:'91vh',overflowY:'auto' }}>
  //         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
  //             <h4 style={{ margin: "10px" }}>Proposal List</h4>
  //             <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
  //         </div>

  //         <div style={{ display: 'flex', justifyContent: 'space-between', width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
  //             <div>
  //                 <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} style={{ padding: "8px 12px", borderRadius: "5px", backgroundColor: 'aliceblue' }}>
  //                     <option value="">Select Year</option>
  //                     {years.map(year => (
  //                         <option key={year} value={year}>{year}</option>
  //                     ))}
  //                 </select>
  //             </div>
  //             <div>
  //                 <select value={selectedTaluka} onChange={(e) => setSelectedTaluka(e.target.value)} style={{ padding: "8px 12px", borderRadius: "5px", backgroundColor: 'aliceblue' }}>
  //                     <option value="">Select Taluka</option>
  //                     {talukas.map(taluka => (
  //                         <option key={taluka} value={taluka}>{taluka}</option>
  //                     ))}
  //                 </select>
  //             </div>
  //         </div>

  //         <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
  //             <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
  //                 <table style={{ width: '100%', borderCollapse: "collapse", minWidth: "1200px", }}>
  //                     <thead>
  //                         <tr style={{ color: 'white', border: 'none', height: '3.5rem' }}>
  //                             <th>Sr.No</th>
  //                             <th>Proposal ID</th>
  //                             <th>Head Code</th>
  //                             <th>Year</th>
  //                             <th>Taluka</th>
  //                             <th>Constituency</th>
  //                             <th>Gram Panchayat</th>
  //                             <th>Work Name</th>
  //                             <th>File Number</th>
  //                             <th>Amount</th>
  //                             <th>Proposal Copy</th>
  //                             <th>Supplement Doc</th>
  //                             <th>Created At</th>
  //                             <th>GR Assigned</th>
  //                         </tr>
  //                     </thead>
  //                     <tbody>
  //                         {currentBills?.map((proposal, index) => {
  //                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
  //                             return (
  //                                 <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor }}>
  //                                     <td>{indexOfFirstBill + index + 1}</td>
  //                                     <td>{proposal.ProposalID}</td>
  //                                     <td>{proposal.HeadCode}</td>
  //                                     <td>{proposal.Proposal_year}</td>
  //                                     <td>{proposal.Taluka}</td>
  //                                     <td>{proposal.Constituency_name}</td>
  //                                     <td>{proposal.Gram_panchayat}</td>
  //                                     <td>{proposal.Work_name}</td>
  //                                     <td>{proposal.Proposal_fileNumber}</td>
  //                                     <td>{proposal.Proposal_amount}</td>
  //                                     <td>
  //                                         {proposal.Proposal_copy ? (
  //                                             <a href={`/uploads/${proposal.Proposal_copy}`} target="_blank" rel="noreferrer">View</a>
  //                                         ) : 'N/A'}
  //                                     </td>
  //                                     <td>
  //                                         {proposal.Additional_suppDoc ? (
  //                                             <a href={`/uploads/${proposal.Additional_suppDoc}`} target="_blank" rel="noreferrer">View</a>
  //                                         ) : 'N/A'}
  //                                     </td>
  //                                     <td>{new Date(proposal.created_at).toLocaleString()}</td>
  //                                     <td>{proposal.GRAssigned === 'true' ? 'Yes' : 'No'}</td>
  //                                 </tr>
  //                             )
  //                         })}
  //                     </tbody>
  //                 </table>
  //             </div>
  //         </div>

  //         <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 10px', height: '3rem', alignItems: 'center' }}>
  //             <div>
  //                 <p>Showing {filteredBills?.length} of {proposallist?.length} entries</p>
  //             </div>
  //             <div style={{ display: 'flex', alignItems: 'center' }}>
  //                 {/* Pagination Controls */}
  //                 <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>&laquo;</button>
  //                 <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>&lt;</button>
  //                 <button>{currentPage}</button>
  //                 <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>&gt;</button>
  //                 <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>&raquo;</button>
  //             </div>
  //         </div>
  //     </div>
  // )
  return (
      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        <div className="col-11 m-auto">
          <div className="col-12">
            <div className="col-12 px-4 mb-4 mt-3">
              {/* Heading */}
              <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                <h5 className="fw-bold d-flex align-items-center m-0">
                  <img
                    src="/GR-Approval64.png"
                    alt="Technical Approval"
                    style={{
                      width: "24px",
                      height: "24px",
                      marginRight: "8px",
                    }}
                  />
                  Proposal List
                </h5>
              </div>

              {/* Filters + Search */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "15px",
                }}
              >
                {/* Left Side Filters */}
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Year Filter */}
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      fontSize: "18px",
                      minWidth: "160px",
                      outline: "none",
                    }}
                  >
                    <option value="">{t("Select Year")}</option>

                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>

                  {/* Taluka Filter */}
                  <select
                    value={selectedTaluka}
                    onChange={(e) => setSelectedTaluka(e.target.value)}
                    style={{
                      padding: "8px 12px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      fontSize: "18px",
                      minWidth: "180px",
                      outline: "none",
                    }}
                  >
                    <option value="">{t("Select Taluka")}</option>

                    {talukas.map((taluka) => (
                      <option key={taluka} value={taluka}>
                        {taluka}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Right Side Search */}
                <div
                  style={{
                    position: "relative",
                    width: "240px",
                  }}
                >
                  <img
                    src="/Search32.png"
                    alt="Search"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                      width: "16px",
                      opacity: 0.6,
                    }}
                  />

                  <input
                    type="text"
                    placeholder={t("Search")}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px 12px 8px 34px",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      fontSize: "18px",
                      outline: "none",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 pb-5 px-5">
          <div
            className="m-auto mb-3"
            style={{
              backgroundColor: "white",
              padding: "40px 40px",
              boxShadow: "0px 0px 5px 1px #E4E8EC",
              borderRadius: "20px",
              width: "100%",
              maxWidth: "100%",
              overflowX: "hidden",
            }}
          >
            <div
              className="col-12 tableDesign"
              style={{ background: "#2C78DB", overflowX: "scroll" }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: "1200px",
                }}
              >
                <thead>
                  <tr
                    style={{ color: "white", border: "none", height: "3.5rem", fontSize: "18px" }}
                  >
                    <th style={{ padding: "7px 10px", minWidth: "20px" }}>{t("Sr.No")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Proposal ID")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "200px" }}>{t("Head Code")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Year")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Taluka")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Constituency")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Gram Panchayat")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "180px" }}>{t("Work Name")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("File Number")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Amount")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Proposal Copy")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Supplement Doc")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("Created At")}</th>
                    <th style={{ padding: "7px 10px", minWidth: "120px" }}>{t("GR Assigned")}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentBills?.map((proposal, index) => {
                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                    return (
                      <tr
                        style={{
                          borderBottom: "1px solid #3b409e",
                          backgroundColor: bgColor,
                          fontSize: "18px",
                        }}
                      >
                        <td style={{ padding: '9px 6px' }}>{indexOfFirstBill + index + 1}</td>
                        <td style={{ padding: '9px 6px' }}>{proposal.ProposalID}</td>
                        <td style={{ padding: '9px 6px' }}>{proposal.HeadCode}</td>
                        <td style={{ padding: '9px 6px' }}>{proposal.Proposal_year}</td>
                        <td style={{ padding: '9px 6px' }}>{proposal.Taluka}</td>
                        <td style={{ padding: '9px 6px' }}>{proposal.Constituency_name}</td>
                        <td style={{ padding: '9px 6px'  , maxWidth: "500px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",}} >{proposal.Gram_panchayat}</td>
                        <td style={{ padding: '9px 6px' ,  maxWidth: "500px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word" }}>{proposal.Work_name}</td>
                        <td style={{ padding: '9px 6px' }}>{proposal.Proposal_fileNumber}</td>
                        <td style={{ padding: "9px 6px" }}>
₹{Number(proposal.Proposal_amount || 0).toLocaleString("en-IN")}
</td>
                        <td style={{ padding: '9px 6px' }}>
                          {proposal.Proposal_copy ? (
                            <a
                              href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {t("View")}{" "}
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td style={{ padding: '9px 6px' }}>
                          {proposal.Additional_suppDoc ? (
                            <a
                              href={`${apiurl}/ProposalFile/${proposal.Additional_suppDoc}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {t("View")}
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </td>
                      <td style={{ padding: "9px 6px" }}>
  {proposal.created_at
    ? new Date(proposal.created_at).toLocaleDateString("en-GB")
    : "-"}
</td>
                        <td style={{ padding: '9px 6px' }}>{proposal.GRAssigned === "true" ? "Yes" : "No"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 10px",
            height: "3rem",
            alignItems: "center",
            marginBottom: "2rem",
          }}
        >
          <div>
            <p>
              {t("Showing")}{" "}
              {filteredBills.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
              {Math.min(indexOfLastBill, filteredBills.length)} of{" "}
              {filteredBills.length} entries
            </p>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <GooglePagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
          </div>
        </div>

      </div>
  );
};

export default ProposalList;
